import { h } from '@stencil/core';
import { DEFAULT_CTA_DROPDOWN_LABEL, tryParse } from '@pes-ui/utils';
import { getData } from '../../../globals/http';
import { RANGE_ENDPOINT } from '../constants';
import { getSelectorConfigUrl } from '../utils/urls';
export class RangeMain {
  constructor() {
    this.getSelectorConfig = () => getData(false, getSelectorConfigUrl(this.localeCode, this.id, this.isExternalConsumer));
    this.host = undefined;
    this.localeCode = undefined;
    this.endpoint = RANGE_ENDPOINT;
    this.rangePartofLabel = undefined;
    this.brandLogo = undefined;
    this.commercialStatus = undefined;
    this.description = undefined;
    this.id = undefined;
    this.image = undefined;
    this.longDescription = undefined;
    this.masterRangeName = undefined;
    this.name = undefined;
    this.rangeCtas = undefined;
    this.rangeId = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.learnMoreLabel = undefined;
    this.moreOptionsLabel = DEFAULT_CTA_DROPDOWN_LABEL;
    this.rangeType = undefined;
    this.requestRangeSelectorConfig = undefined;
    this.isExternalConsumer = undefined;
    this._host = undefined;
    this._localeCode = undefined;
    this._endpoint = undefined;
    this._rangePartofLabel = undefined;
    this._brandLogo = undefined;
    this._commercialStatus = undefined;
    this._description = undefined;
    this._id = undefined;
    this._image = undefined;
    this._longDescription = undefined;
    this._masterRangeName = undefined;
    this._name = undefined;
    this._rangeCtas = undefined;
    this._rangeId = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._learnMoreLabel = undefined;
    this._moreOptionsLabel = undefined;
    this._rangeType = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    window.scrollTo(0, 0);
    this.host = (_a = tryParse(this._host)) !== null && _a !== void 0 ? _a : this.host;
    this.localeCode = (_b = tryParse(this._localeCode)) !== null && _b !== void 0 ? _b : this.localeCode;
    this.endpoint = (_c = tryParse(this._endpoint)) !== null && _c !== void 0 ? _c : this.endpoint;
    this.rangePartofLabel = (_d = tryParse(this._rangePartofLabel)) !== null && _d !== void 0 ? _d : this.rangePartofLabel;
    this.brandLogo = (_e = tryParse(this._brandLogo)) !== null && _e !== void 0 ? _e : this.brandLogo;
    this.commercialStatus = (_f = tryParse(this._commercialStatus)) !== null && _f !== void 0 ? _f : this.commercialStatus;
    this.description = (_g = tryParse(this._description)) !== null && _g !== void 0 ? _g : this.description;
    this.id = (_h = tryParse(this._id)) !== null && _h !== void 0 ? _h : this.id;
    this.image = (_j = tryParse(this._image)) !== null && _j !== void 0 ? _j : this.image;
    this.longDescription = (_k = tryParse(this._longDescription)) !== null && _k !== void 0 ? _k : this.longDescription;
    this.masterRangeName = (_l = tryParse(this._masterRangeName)) !== null && _l !== void 0 ? _l : this.masterRangeName;
    this.name = (_m = tryParse(this._name)) !== null && _m !== void 0 ? _m : this.name;
    this.rangeCtas = (_o = tryParse(this._rangeCtas)) !== null && _o !== void 0 ? _o : this.rangeCtas;
    this.rangeId = (_p = tryParse(this._rangeId)) !== null && _p !== void 0 ? _p : this.rangeId;
    this.readMoreLabel = (_q = tryParse(this._readMoreLabel)) !== null && _q !== void 0 ? _q : this.readMoreLabel;
    this.readLessLabel = (_r = tryParse(this._readLessLabel)) !== null && _r !== void 0 ? _r : this.readLessLabel;
    this.learnMoreLabel = (_s = tryParse(this._learnMoreLabel)) !== null && _s !== void 0 ? _s : this.learnMoreLabel;
    this.moreOptionsLabel = (_t = tryParse(this._moreOptionsLabel)) !== null && _t !== void 0 ? _t : this.moreOptionsLabel;
    this.rangeType = (_u = tryParse(this._rangeType)) !== null && _u !== void 0 ? _u : this.rangeType;
  }
  render() {
    return (h("section", { class: "range-wrapper" }, h("div", { class: "range-main" }, h("pes-range-info", { image: this.image, name: this.name, description: this.description, masterRangeName: this.masterRangeName, longDescription: this.longDescription, rangePartofLabel: this.rangePartofLabel, commercialStatus: this.commercialStatus, brandLogo: this.brandLogo, rangeCtas: this.rangeCtas, getSelectorConfig: this.requestRangeSelectorConfig || this.getSelectorConfig, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, learnMoreLabel: this.learnMoreLabel, isExternalConsumer: this.isExternalConsumer, moreOptionsLabel: this.moreOptionsLabel, rangeType: this.rangeType }), h("pes-range-cta", { class: "range-main-cta-button-block", rangeCtas: this.rangeCtas, moreOptionsLabel: this.moreOptionsLabel, getSelectorConfig: this.requestRangeSelectorConfig || this.getSelectorConfig }))));
  }
  static get is() { return "pes-range-main"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-main.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-main.css"]
    };
  }
  static get properties() {
    return {
      "host": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://se.com/"
            }],
          "text": "Rest host url."
        },
        "attribute": "host",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "'/apc/WW/en' or '/WW/en' or '/FR/fr'"
            }],
          "text": "Locale code"
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "endpoint": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Rest api endpoint. 'product/' uses only."
        },
        "attribute": "endpoint",
        "reflect": false,
        "defaultValue": "RANGE_ENDPOINT"
      },
      "rangePartofLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "'Master Range&nbsp;#MasterRangeName#'"
            }],
          "text": "Label for master range."
        },
        "attribute": "range-partof-label",
        "reflect": false
      },
      "brandLogo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "LogoInfo",
          "resolved": "{ alt?: string; url?: string; }",
          "references": {
            "LogoInfo": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Brand logo."
        }
      },
      "commercialStatus": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CategoriesApi.CommercialStatus",
          "resolved": "{ color?: string; status?: CommercialStatusType; label?: string; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range commercial status."
        }
      },
      "description": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range description."
        },
        "attribute": "description",
        "reflect": false
      },
      "id": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Range id."
        },
        "attribute": "id",
        "reflect": false
      },
      "image": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "ImageLink",
          "resolved": "{ title?: string; url?: string; alt?: string; }",
          "references": {
            "ImageLink": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range image."
        }
      },
      "longDescription": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range long description."
        },
        "attribute": "long-description",
        "reflect": false
      },
      "masterRangeName": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Master range name."
        },
        "attribute": "master-range-name",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range name."
        },
        "attribute": "name",
        "reflect": false
      },
      "rangeCtas": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TRangeCTAs",
          "resolved": "TRangeCTAItem[]",
          "references": {
            "TRangeCTAs": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range cta."
        }
      },
      "rangeId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range Id."
        },
        "attribute": "range-id",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Range requestRangeSelectorConfig."
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "learnMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "learn-more-label",
        "reflect": false
      },
      "moreOptionsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "more-options-label",
        "reflect": false,
        "defaultValue": "DEFAULT_CTA_DROPDOWN_LABEL"
      },
      "rangeType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-type",
        "reflect": false
      },
      "requestRangeSelectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "() => Promise<{\n    label: string;\n    config: TProductSelectorConfig;\n    labels: TProductCtasLabels;\n  }>",
          "resolved": "() => Promise<{ label: string; config: TProductSelectorConfig; labels: TProductCtasLabels; }>",
          "references": {
            "Promise": {
              "location": "global"
            },
            "TProductSelectorConfig": {
              "location": "import",
              "path": "../../UI/product-selector/commonTypes"
            },
            "TProductCtasLabels": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "_host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-host",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "_endpoint": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-endpoint",
        "reflect": false
      },
      "_rangePartofLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-partof-label",
        "reflect": false
      },
      "_brandLogo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-brand-logo",
        "reflect": false
      },
      "_commercialStatus": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-commercial-status",
        "reflect": false
      },
      "_description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-description",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-id",
        "reflect": false
      },
      "_image": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-image",
        "reflect": false
      },
      "_longDescription": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-long-description",
        "reflect": false
      },
      "_masterRangeName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-master-range-name",
        "reflect": false
      },
      "_name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-name",
        "reflect": false
      },
      "_rangeCtas": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-ctas",
        "reflect": false
      },
      "_rangeId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-id",
        "reflect": false
      },
      "_readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-more-label",
        "reflect": false
      },
      "_readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-less-label",
        "reflect": false
      },
      "_learnMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-learn-more-label",
        "reflect": false
      },
      "_moreOptionsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-more-options-label",
        "reflect": false
      },
      "_rangeType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-type",
        "reflect": false
      }
    };
  }
}
